import { spUrl } from "utils";
import { request } from "utils/proxy";
import { API_SHELL } from "globals/constants";


export const shell = {
	get: (options) => request(spUrl(API_SHELL), options),
};
